/**
 * Moduł leasingu - udostępnia akcje biznesowe związane z leasingiem na ścieżce:
 * rozpoczęcie i kontynuację wniosku.
 */

app.service('leasing', function (loading, modal, console) {
	let isBlocked = false;
	const defaultErrorMessage = 'Wystąpiły problemy techniczne. Spróbuj ponownie później.';

	function startLeaseApplication(orderNumber) {
		sendLeaseRequest({
			orderNumber: orderNumber,
			type: 'POST',
			url: '/leasing-application-init.ltr'
		});
	}

	function sendLeaseRequest(config) {
		if (isBlocked) {
			console.log('Akcja leasingowa jest już wykonywana');
			return;
		}

		isBlocked = true;

		if (!modal.isOpen('leasing-count')) {
			loading.start();
		}

		$.ajax({
			type: config.type,
			url: config.url,
			dataType: 'json',
			data: {
				orderNumber: config.orderNumber
			},
			success: function (response) {
				modal.close('leasing-count');
				loading.redirect({
					href: response.redirectUrl,
					soft: false
				});
			},
			error: function (xhr, textStatus) {
				isBlocked = false;
				console.log('Akcja leasingowa nie udała się, status: ' + xhr.status + ', textStatus: ' + textStatus);
				showError();
			}
		});
	}

	function showError() {
		loading.stop();
		modal.close('leasing-count');
		modal.alert(defaultErrorMessage);
	}

	return {
		startLeaseApplication
	};
});
